import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZoomOut = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 41,
	viewBox: "0 0 41 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.6667 26.3333C23.3486 26.3333 26.3333 23.3486 26.3333 19.6667C26.3333 15.9848 23.3486 13 19.6667 13C15.9848 13 13 15.9848 13 19.6667C13 23.3486 15.9848 26.3333 19.6667 26.3333Z",
			stroke: "#50566E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 28L24.375 24.375",
			stroke: "#50566E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.167 19.667H22.167",
			stroke: "#50566E",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgZoomOut;
